import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* cardPointDataWatchers() {
  yield all([
    takeEvery(EntryActionTypes.CARD_POINT_DATA_IN_CURRENT_CARD_FETCH, () =>
      services.fetchCardPointDataInCurrentCard(),
    ),
    takeEvery(EntryActionTypes.CARD_POINT_DATA_IN_CURRENT_CARD_UPSERT, ({ payload: { data } }) =>
      services.upsertCardPointDataInCurrentCard(data),
    ),
    takeEvery(EntryActionTypes.CARD_POINT_DATA_IN_CURRENT_CARD_COMPLETE, ({ payload: { taskClosedAt } }) =>
      services.completeCardPointDataInCurrentCard(taskClosedAt),
    ),
    takeEvery(EntryActionTypes.CARD_POINT_DATA_IN_CURRENT_CARD_UNCOMPLETE, () =>
      services.uncompleteCardPointDataInCurrentCard(),
    ),
  ]);
}

